import { Injectable } from '@angular/core';
import { HttpService } from '@etop/common';
import { AuthenticateStore } from '@etop/core';
import {CursorPaging, Hotline} from "@etop/models";

@Injectable({
  providedIn: 'root'
})
export class HotlineApi {
  constructor(
    private http: HttpService,
    private auth: AuthenticateStore
  ) {
  }

  async getHotlines() {
    return await this.http.post('api/shop.Etelecom/GetHotlines', {}).toPromise().then(
      (res) => {
        res.hotlines = res.hotlines.map((hotline) => Hotline.hotlineMap(hotline));
        return res.hotlines;
      });
  }

  async getListHotlines(request: HotlinesAPI.GetHotlinesRequest) {
    return await this.http.post('api/shop.Etelecom/GetHotlines', request).toPromise().then(
      (res) => res);
  }

  async updateHotlineForExtension(hotline_id: string) {
    return this.http.post('api/shop.Etelecom/UpdateHotlineForExtension', {hotline_id}).toPromise();
  }

}

export namespace HotlinesAPI {
    export class GetHotlinesRequest {
      filter?: GetHotlinesFilter;
      paging?: CursorPaging
    }
    export class GetHotlinesFilter {
      tenant_id?: string;
      owner_id?: string;
      hotline_ids?: string[];
      hotline?: string;
      name?: string;
      network?: string;
      connection_id?: string;
    }
  }
